import { getSnapshot, subscribe } from '@/utils/storage';
import { useSyncExternalStore } from 'react';

export function useLocalStorageSync(key: string) {
  return useSyncExternalStore(
    subscribe, // subscribe to changes
    () => getSnapshot(key), // get current snapshot
    () => getSnapshot(key) // get server snapshot (same here)
  );
}
